import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const RatesContext = createContext();

export const RatesProvider = ({ children }) => {
  const [rates, setRates] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState(localStorage.getItem("currency") || "USD");

  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/rates`);
        setRates(response.data);
      } catch (error) {
        console.error("Error fetching currency rates:", error);
      }
    };

    fetchRates();
  }, []);

  // Function to convert UXB to the selected currency
  const convertBalance = (balance) => {
    if (!rates || !rates.currencies || selectedCurrency === "UXB") {
      return formatNumber(balance); // If no rates or selected currency is UXB, return original balance
    }

    const targetCurrency = rates.currencies.find((c) => c.currency_short_name === selectedCurrency);
    if (!targetCurrency) return formatNumber(balance); // If currency not found, return original balance

    // Get conversion rate based on the selected currency
    const conversionRate = targetCurrency.currency_value;

    return formatNumber(balance * conversionRate);
  };

  // Format numbers with commas
  const formatNumber = (num) => {
    return new Intl.NumberFormat("en-US").format(num);
  };

  return (
    <RatesContext.Provider value={{ rates, selectedCurrency, setSelectedCurrency, convertBalance }}>
      {children}
    </RatesContext.Provider>
  );
};

// Custom hook for easy access
export const useRates = () => useContext(RatesContext);
